import Common from "./Common";
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import Settings from "./Settings";;



const createRootReducer = (history) => 
combineReducers({
  router: connectRouter(history),
  settings: Settings,
  common: Common,
});

export default createRootReducer;
